import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import GenieConversation from './chatbot/GenieConversation';
import AgentAssistantConversation from './chatbot/AgentAssistantConversation';
import TransmissionUploadModal from './chatbot/TransmissionUploadModal';

interface HeaderProps {
  title?: string;
  subtitle?: string;
}

export default function Header({ title, subtitle }: HeaderProps) {
  const location = useLocation();
  let GenieConvo = <></>
  let AgentConvo = <></>
  let TransmissionConvo = <></>

  if (location.pathname === '/genie') {
    GenieConvo = <GenieConversation />
  }

  if (location.pathname === '/agent-assistant') {
    AgentConvo = <AgentAssistantConversation />
  }

  if (location.pathname === '/transmission') {
    TransmissionConvo = <TransmissionUploadModal />
  }

  return (
    <AppBar position="static" color="transparent">
      <Toolbar>
        <img src="/cnhi-logo.png" height="75" alt="logo" />
        <div style={{ display: 'flex', flexDirection: 'column', marginRight: '20px' }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ textAlign: "left", color: '#a71930', fontWeight: 800 }}
          >
            {title}
          </Typography>
          <Typography
            variant="h6"
            component="div"
            sx={{ 
              textAlign: "left", 
              color: '#000', 
              fontWeight: 600, 
              fontSize: '14px',
              lineHeight: 1.2,
              maxWidth: '900px'
            }}
          >
            {subtitle}
          </Typography>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          {GenieConvo}
          {AgentConvo}
          {TransmissionConvo}
        </div>
      </Toolbar>
    </AppBar>
  );
}